import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductCategory } from './models/ProductCategory';
import { DangerousGoodsCode } from './models/DangerousGoodsCode';
import { ProductDescription } from './models/ProductDescription';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  constructor(private readonly http$: HttpClient) { }

  getProductCategories(freightPayerId: number, workTypeId: number = 1, onlyTimeBased: boolean = false): Observable<ProductCategory[]> {
    const params = new HttpParams()
      .set('freightPayerId', freightPayerId)
      .set('workTypeId', workTypeId)
      .set('onlyTimeBased', onlyTimeBased.toString());

    return this.http$.get<ProductCategory[]>(`/api/product/categories`, { params });
  }

  getDangerousGoodsCodes() {
    return this.http$.get<DangerousGoodsCode[]>('/api/product/dangerousGoodsCodes');
  }

  getProductDescriptionsForCategory(categoryId: number) {
    return this.http$.get<ProductDescription[]>(`/api/product/categories/descriptions/${categoryId}`);
  }

  createProductDescription(categoryId: number, description: string) {
    const body = {
      description
    }
    return this.http$.post<ProductCategory>(`/api/product/categories/${categoryId}/createDescription`, body);
  }
}
